"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const menuButtons_1 = require("../models/menuButtons");
const libelles_1 = require("../models/libelles");
const lists_1 = require("../models/lists");
function emailObligatoire(value, config) {
    // @ts-ignore
    if (!webix.rules.isEmail(value)) {
        return { "background-color": "#FFDEDB" };
    }
}
;
class UsersGrid extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "utilisateurs",
            datatableName: "utilisateursdatatable",
            columns: [
                {
                    id: "unid", header: (0, globals_1._)("N°"), width: 40,
                    css: { "text-align": "right" }, sort: "int", hidden: false
                },
                { id: "nom", editor: "text", header: (0, globals_1._)("Nom"), width: 140, sort: "text", maxlength: 24 },
                { id: "prenom", editor: "text", maxlength: 18,
                    header: (0, globals_1._)("Prénom"), width: 100, sort: "text" },
                { id: "telephone", editor: "text", header: (0, globals_1._)("Téléphone"), width: 140, sort: "text",
                    maxlength: 24 },
                { id: "mobile", editor: "text", header: (0, globals_1._)("Mobile"), width: 140, sort: "text",
                    maxlength: 18 },
                { id: "email", type: "email", editor: "text", header: (0, globals_1._)("Courriel"), width: 200, sort: "text",
                    maxlength: 40, cssFormat: emailObligatoire },
                { id: "nomCourt", editor: "text", header: (0, globals_1._)("Identifiant"), width: 120, sort: "text",
                    maxlength: 12 },
                { id: "idProfilUtilisateur", editor: "richselect", header: (0, globals_1._)("Profil"), width: 120, sort: "text",
                    options: libelles_1.profilUtilisateurList },
                { id: "langue", header: (0, globals_1._)("Langue"),
                    width: 120, sort: "text", options: lists_1.localesList },
                { id: "compteActif", template: "{common.checkbox()}" // , editor : "checkbox"
                    ,
                    header: (0, globals_1._)("Actif"), width: 60, sort: "int",
                    uncheckValue: "0", value: "0", checkValue: "1" },
                { id: "finAutorisation", editor: "date", header: (0, globals_1._)("Jusqu'au"), width: 140, sort: "date",
                    format: webix.i18n.dateFormatStr
                }
            ],
            title: (0, globals_1._)("Membres"),
            boutons: [menuButtons_1.ajouterButton, menuButtons_1.supprimerButton],
            multiselect: false,
            resizeColumn: true,
            urlData: globals_1.phpPath + "utilisateurs.php?option=list",
            saveData: {
                updateFromResponse: true,
                "insert": globals_1.phpPath + "utilisateurs.php?option=insertEmpty",
                "update": globals_1.phpPath + "utilisateurs.php?option=update",
                "delete": globals_1.phpPath + "utilisateurs.php?option=delete",
            },
            rules: {
            // email : webix.rules.isEmail		//	Supprimé, car bloque l'enregistrement et donc les valeurs par défaut
            }
        });
        // @ts-ignore
        this.defaultValues = { "compteActif": 1, "langue": langue, "idProfilUtilisateur": 4 };
        this.firstFocusField = "nom";
    }
    setDefaultValues(record) {
        let dtable = this.currentGrid;
        if (this.defaultValues) {
            dtable.updateItem(record.id, this.defaultValues);
        }
        dtable.editCell(record.id, this.firstFocusField);
    }
    // afterSaveError(id, status, response) {
    // 	webix.message(reponse.message);
    // }
    ready() {
        let me = this;
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "button-add":
                    me.ajouter();
                    break;
                case "button-del":
                    me.supprimer();
                    break;
            }
        });
        menu.hideMenuItem("button-del");
        menu.hideMenuItem("button-add");
        if ((globals_1.lv2.droits).includes(this.moduleName + ".insertEmpty,")) {
            menu.showMenuItem("button-add");
        }
        if ((globals_1.lv2.droits).includes(this.moduleName + ".delete,")) {
            menu.showMenuItem("button-del");
        }
        // gestion des erreurs
        let dp = webix.dp(this.datatableName);
        dp.attachEvent("onAfterSaveError", function (id, status, response) {
            webix.alert({
                text: (response.message),
                modal: true
            }).then(function () {
                if (response.rule == 100) {
                    me.currentGrid.getItem(id).email = "";
                    me.currentGrid.editCell(id, "email");
                }
                if (response.rule == 101) {
                    me.currentGrid.getItem(id).nomCourt = "";
                    me.currentGrid.editCell(id, "nomCourt");
                }
            });
        });
        // nettoyage de tous les champs texte
        this.currentGrid.attachEvent("onBeforeEditStop", function (state, editor, ignore) {
            let textFields = ["nom", "prenom", "telephone", "mobile", "email", "nomCourt"];
            if (textFields.includes(editor.column)) {
                state.value = globals_1.lv2.verifTexte(state.value);
                return;
            }
        });
    }
}
exports.default = UsersGrid;
